import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "str_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const add = (product, qty = 1) => {
    setItems((prev) => {
      const existing = prev.find((i) => i.id === product.id);
      const max = product.available ?? product.quantity;
      if (existing) {
        return prev.map((i) => i.id === product.id ? { ...i, qty: Math.min(max, i.qty + qty) } : i);
      }
      return [...prev, {
        id: product.id, name: product.name, our_price: product.our_price,
        image: (product.images && product.images[0]) || "", condition: product.condition,
        max, qty: Math.min(max, qty),
      }];
    });
    setOpen(true);
  };

  const setQty = (id, qty) =>
    setItems((prev) => prev.map((i) => i.id === id ? { ...i, qty: Math.max(1, Math.min(i.max, qty)) } : i));
  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + i.our_price * i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
